////////////////////////////////////////////
//
// Foundation Functions
//
////////////////////////////////////////////


// This syntax and some commands are taken from...
// node_modules/foundation-sites/js/entries/foundation.js

import { Foundation } from 'foundation-sites/js/foundation.core';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
// import { Tabs } from 'foundation-sites/js/foundation.tabs';
import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu';

Foundation.addToJquery($);
Foundation.plugin(AccordionMenu, 'AccordionMenu');
Foundation.plugin(Dropdown, 'Dropdown');

$(document).foundation();
